export default function (axios, config) {
  const importMap = function (row) {
    return {
      id: row.id,
      date: row.field_datum,
      type: row.type,
      diagnosis: row.field_diagnoseart,
      bee_mass: row.field_bienenmasse,
      days: row.field_anzahl_tage,
      mites: row.field_anzahl_milben,
      medicine: row.field_medikamente,
      other_medicine: row.field_medikament,
      amount: (row.type === 'massnahme_honigernte' ? row.field_honigmenge : row.field_menge),
      biotech: row.field_biotechnik_methoden,
      other_biotech: row.field_biotechnik_methode,
      swarm_prevention: row.field_sv_methoden,
      other_swarm_prevention: row.field_sv_methode,
      feed: row.field_fg_methoden,
      other_feed: row.field_fg_methode,
      honey_type: row.field_honigart,
      space_management: row.field_rm_methoden
    }
  }

  const types = [
    'massnahme_varroa_diagnose',
    'massnahme_varroa_medikamente',
    'massnahme_varroa_biotechnik',
    'massnahme_schwarmverhinderung',
    'massnahme_futtergabe',
    'massnahme_honigernte',
    'massnahme_raummanagement'
  ]

  return {
    invalidate () {
      this.getAll.invalidate()
      this.getOne.invalidate()
    },
    getAll: config.cachedFunction(async function (colony) {
      const response = await axios({
        url: config.serverUrl + '/api/node/' + colony + '?_format=json',
        method: 'get',
        withCredentials: true
      })

      const colonyData = Object.values(response.data.result)[0]

      if (!colonyData || !colonyData.field_massnahmen_und_aktionen) return []

      return Object.values(colonyData.field_massnahmen_und_aktionen)
        .filter(function (row) {
          return types.includes(row.type)
        })
        .map(function (row) {
          return importMap(row)
        })
    }),
    getOne: config.cachedFunction(async function (id) {
      const response = await axios({
        url: config.serverUrl + '/api/paragraph/' + id + '?_format=json',
        method: 'get',
        withCredentials: true
      })

      if (!response.data.result) return null

      const row = Object.values(response.data.result)[0]
      return importMap(row)
    }),
    async save ({ id, colony, diagnosis, mites, days, beeMass, medicine, amount, otherMedicine, biotech, otherBiotech, swarmPrevention, otherSwarmPrevention, feed, otherFeed, honeyType, spaceManagement, date, type, token }) {
      this.invalidate()
      const data = {
        field_datum: date,
        field_diagnoseart: diagnosis,
        field_bienenmasse: beeMass,
        field_anzahl_tage: days,
        field_anzahl_milben: mites,
        field_medikamente: medicine,
        field_medikament: otherMedicine,
        field_menge: amount,
        field_biotechnik_methoden: biotech,
        field_biotechnik_methode: otherBiotech,
        field_sv_methoden: swarmPrevention,
        field_sv_methode: otherSwarmPrevention,
        field_fg_methoden: feed,
        field_fg_methode: otherFeed,
        field_honigart: honeyType,
        field_honigmenge: amount,
        field_rm_methoden: spaceManagement,
        type
      }

      const url = (id ? config.serverUrl + '/api/paragraph/' + id + '?_format=json' : config.serverUrl + '/api/node/' + colony + '?_format=json')
      // console.log(url)
      // console.log(data)

      const measureResult = await axios({
        url,
        method: 'patch',
        data: (id ? data : {
          field_massnahmen_und_aktionen: [data]
        }),
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })

      const measure = Object.values(measureResult.data.result)[0]
      // console.log('ID: ', id)
      if (id) {
        // patch colony to reset Drupal-cache
        await axios({
          url: config.serverUrl + '/api/node/' + colony + '?_format=json',
          method: 'patch',
          data: {},
          withCredentials: true,
          headers: {
            'X-CSRF-Token': token
          }
        })
      }

      return measure
    },
    async deleteItem ({ id, colony, token }) {
      this.invalidate()
      const url = config.serverUrl + '/api/paragraph/' + id + '?_format=json'

      const deleteResult = await axios({
        url,
        method: 'delete',
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
      // console.log(deleteResult)
      if (deleteResult.status === 204) {
        // patch colony to reset Drupal-cache
        // eslint-disable-next-line no-return-await
        return await axios({
          url: config.serverUrl + '/api/node/' + colony + '?_format=json',
          method: 'patch',
          data: {},
          withCredentials: true,
          headers: {
            'X-CSRF-Token': token
          }
        })
      }
    }
  }
}
